import { WeekDays } from "./WeekDays";


export interface OpenHours {
    dayOfWeek: WeekDays;
    openHour: string;
    closingHour: string;
}

export const DEFAULT_OPENING_HOURS : OpenHours[] = [
    {dayOfWeek: WeekDays.SUNDAY, openHour: "11 AM", closingHour: "9 PM"},
    {dayOfWeek: WeekDays.MONDAY, openHour: "11 AM", closingHour: "9 PM"},
    {dayOfWeek: WeekDays.TUESDAY, openHour: "11 AM", closingHour: "9 PM"},
    {dayOfWeek: WeekDays.WEDNESDAY, openHour: "", closingHour: ""},
    {dayOfWeek: WeekDays.THURSDAY, openHour: "11 AM", closingHour: "9 PM"},
    {dayOfWeek: WeekDays.FRIDAY, openHour: "11 AM", closingHour: "9 PM"},
    {dayOfWeek: WeekDays.SATURDAY, openHour: "11 AM", closingHour: "9 PM"}
];